<script setup>
    import { defineProps } from "vue";

    const props = defineProps({
        iconWidth: String,
        iconHeight: String,
    });
</script>


<template>
    <svg 
        :width="iconWidth" 
        :height="iconHeight" 
        viewBox="0 0 20 20" 
        version="1.1" 
        xmlns="http://www.w3.org/2000/svg" 
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g 
            stroke="none" 
            stroke-width="1" 
            fill="none" 
            fill-rule="evenodd"
        >
            <g 
                transform="translate(-300.000000, -1239.000000)" 
                fill="currentColor"
            >
                <g 
                    transform="translate(56.000000, 160.000000)"
                >
                    <path 
                        d="M264,1085.8377 L264,1088.1047 C264,1088.6567 263.526,1089.0007 262.973,1089.0007 L262.947,1089.0007 
                            C262.394,1089.0007 262,1088.6567 262,1088.1047 L262,1087.0007 L257.893,1087.0007 C256.788,1087.0007 
                            256,1086.2097 256,1085.1047 L256,1081.0007 L246.893,1081.0007 C246.341,1081.0007 246,1081.5527 
                            246,1082.1047 L246,1088.1047 C246,1088.6567 245.526,1089.0007 244.973,1089.0007 L244.947,1089.0007 
                            C244.394,1089.0007 244,1088.6567 244,1088.1047 L244,1081.1047 C244,1080.0007 244.788,1079.0007 
                            245.893,1079.0007 L257.443,1079.0007 C257.717,1079.0007 258.006,1079.1647 258.195,1079.3637 
                            L263.671,1085.1487 C263.848,1085.3347 264,1085.5817 264,1085.8377 L264,1085.8377 Z M255.973,1091.0007 
                            C255.969,1091.0007 255.965,1091.0037 255.96,1091.0037 C255.955,1091.0037 255.951,1091.0007 255.947,1091.0007 
                            L255.973,1091.0007 Z M257,1092.1047 L257,1098.1047 C257,1098.6567 256.445,1099.0007 255.893,1099.0007 
                            L255.202,1099.0007 C255.013,1099.0007 254.893,1098.9457 254.808,1098.7767 L253,1095.1047 L253,1098.1047 
                            C253,1098.6567 252.526,1099.0007 251.973,1099.0007 L251.947,1099.0007 C251.394,1099.0007 251,1098.6567 
                            251,1098.1047 L251,1092.1047 C251,1091.5527 251.341,1091.0007 251.893,1091.0007 L252.584,1091.0007 
                            C252.773,1091.0007 253,1091.1597 253.085,1091.3287 L255,1095.1047 L255,1092.1047 C255,1091.5577 
                            255.415,1091.0127 255.96,1091.0037 C256.507,1091.0127 257,1091.5577 257,1092.1047 L257,1092.1047 Z 
                            M262.973,1095.0007 C262.969,1095.0007 262.965,1095.0037 262.96,1095.0037 C262.955,1095.0037 
                            262.951,1095.0007 262.947,1095.0007 L262.973,1095.0007 Z M264,1092.0267 L264,1092.0527 C264,1092.6047 
                            263.445,1093.0007 262.893,1093.0007 L262,1093.0007 C261.004,1093.0007 260.134,1093.7337 259.974,1094.7167 
                            C259.77,1095.9697 261,1097.1047 262,1097.1047 L262,1096.1047 C262,1095.5577 262.415,1095.0127 262.96,1095.0037 
                            C263.507,1095.0127 264,1095.5577 264,1096.1047 L264,1098.1047 C264,1098.6567 263.445,1099.0007 262.893,1099.0007 
                            L262.065,1099.0007 C259.976,1099.0007 258.11,1097.4727 257.912,1095.3937 C257.684,1093.0077 259.554,1091.0007 
                            261.893,1091.0007 L262.893,1091.0007 C263.445,1091.0007 264,1091.4747 264,1092.0267 L264,1092.0267 Z 
                            M246.893,1095.1047 L245.893,1095.1047 L245.893,1093.1047 L246.893,1093.1047 C247.445,1093.1047 
                            247.893,1093.5527 247.893,1094.1047 C247.893,1094.6567 247.445,1095.1047 246.893,1095.1047 
                            L246.893,1095.1047 Z M246.723,1091.0007 L244.893,1091.0007 C244.341,1091.0007 244,1091.5527 
                            244,1092.1047 L244,1098.1047 C244,1098.6567 244.394,1099.0007 244.947,1099.0007 L244.973,1099.0007 
                            C245.526,1099.0007 246,1098.6567 246,1098.1047 L246,1097.0007 L246.893,1097.0007 C248.603,1097.0007 
                            249.979,1095.5697 249.889,1093.8387 C249.804,1092.2167 248.348,1091.0007 246.723,1091.0007 L246.723,1091.0007 Z"
                        >
                    </path>
                </g>
            </g>
        </g>
    </svg>
</template>